export default __webpack_public_path__ + "static/media/add-comments.08c4e790.svg";